import React, { Component } from 'react';
import SearchForm from './search-form/search-form-container';
import SearchResult from './search-result/search-result-container';

class SearchContainer extends Component {
    render() {
        return (
            <div>
                <SearchForm />
                <SearchResult />
            </div>
        );
    }
}

export default SearchContainer;
